import { useEffect } from 'react';
import { PerfUtilService } from '../services/util/perf-util.service';

/**
 * Calls callback initially and each time on resize.
 * @param callback
 * @param debounceDelay
 */
export const useCallbackOnInitAndResizeHook = ({
    callback,
    debounceDelay = 100,
}) => {
    useEffect(() => {
        if (typeof callback !== 'function') {
            return;
        }

        // initial call
        callback();

        // recall on resize
        const debouncedCall = PerfUtilService.debounce(callback, debounceDelay);
        window.addEventListener('resize', debouncedCall);

        return () => {
            window.removeEventListener('resize', debouncedCall);
        };
    }, [callback, debounceDelay]);
};
